export const chartColorsMixin = {
  data() {
    return {
      green: "#92D284",
      yellow: "#F9C74F",
      orange: "#E98A11",
      resultsGreen: "#2E8234",
      red: "#FF6A60",
      green1: "#92D284",
      green2: "#8BB12A",
      green3: "#4FAA34",
      green4: "#359736",
      green5: "#2E8234",
      green6: "#235c27",
      green7: "#1b4a1f",
      green8: "#18401b",
      green9: "#123014",
      green10: "#0b1f0d"
    };
  }
};
